import {MessageBox} from 'element-ui'

/**
 * @author yan st
 * @date 2024-07-19 14:31
 * @Description:
 */
import store from "@/store";
import router from "@/router";
import {Toast} from "vant";

export const toast = (msg) => {
    Toast(msg)
}


export const loading = (msg = '正在加载...') => {
    Toast.loading({message: msg, forbidClick: true, duration: 0});
}
export const loaded = () => {
    Toast.clear()
}

export const scrollIntoView = (_this, validates) => {
    let error = Object.values(validates).shift().shift()
    console.log(error)
    let split = error.field.split('.')
    if (split.length > 3) {
        split.splice(2, 2)
    }
    let refs = _this.$refs[split.join('')]
    let dom = refs instanceof Array ? refs[0] : refs
    // _this.$confirm(error.message, "提示", {
    //   confirmButtonText: "确定",
    //   showCancelButton: false,
    //   type: "warning",
    // }).then(() => {
    dom.$el.scrollIntoView({
        block: 'center', // 当前元素显示在视图区域中间
        behavior: 'auto' // 滚动速度
    })
    // }).catch(() => {
    //
    // })
}

/*
* 退出
* */
export const logout = () => {
    store.dispatch('LogOut').then(() => {
        toLogin()
    })
}

/*
* 跳转登录
* */
export const toLogin = () => {
    router.replace(_isMobile() ? `/mobile/login` : `/login`)
}

/**
 * 获取Token
 */
export const getToken = () => {
    let user = JSON.parse(window.localStorage.getItem('user'))
    return user ? {token: user.token} : '';
}


/*
* 时间转换
* */
export const zhDate = (date, type) => {
    if (!date) return ''
    let now = new Date(isString(date) ? date.replaceAll('-', '/') : date)
    let year = now.getFullYear()
    let month = now.getMonth() + 1
    let day = now.getDate()
    let hour = now.getHours()
    let minute = now.getMinutes()
    let second = now.getSeconds()
    if (type === 1) {
        return year + "-" + getzf(month) + "-" + getzf(day) + " " + getzf(hour) + ":" + getzf(minute)
    } else if (type === 2) {
        return year + "-" + getzf(month) + "-" + getzf(day) + " " + getzf(hour) + ":" + getzf(minute) + ":" + getzf(second)
    } else if (type === 3) {
        return getzf(hour) + ":" + getzf(minute)
    } else if (type === 4) {
        return year
    } else if (type === 5) {
        return year + "-" + getzf(month)
    } else if (type === 6) {
        return getzf(month) + "月" + getzf(day) + "日 " + getzf(hour) + ":" + getzf(minute)
    } else if (type === 7) {
        return year + "/" + getzf(month) + "/" + getzf(day)
    } else {
        return year + "-" + getzf(month) + "-" + getzf(day)
    }
}
export const getzf = (num) => {
    if (parseInt(num) < 10) {
        num = '0' + num
    }
    return num
}


/*
* 判断登录方式
* */
export const browserRedirect = () => {   //  1 手机 2 pc
    let sUserAgent = navigator.userAgent.toLowerCase();
    let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    let bIsMidp = sUserAgent.match(/midp/i) == "midp";
    let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    let bIsAndroid = sUserAgent.match(/android/i) == "android";
    let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        return 1
    } else {
        return 2
    }
}
export const _isMobile = () => {   //  1 手机 2 pc
    return browserRedirect() === 1
}

/*
* 微信登
* */
export const wxOauth2Url = (isMobile = true, path = '', query = '') => {
    if (isMobile) {
        return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe29f7c134eb2eb80&redirect_uri=${path ? path : `${location.origin}${location.pathname}`}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    } else {
        return `https://open.weixin.qq.com/connect/qrconnect?appid=wxe29f7c134eb2eb80&redirect_uri=${location.origin}${location.pathname}${query}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    }
    // return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa8ead9bb1a039de5&redirect_uri=http://lkz.data.shzzpt.org.cn&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
    // return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa8ead9bb1a039de5&redirect_uri=http://lkz.data.shzzpt.org.cn&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
}


export const resetLocationUrl = (param = '') => {
    history.replaceState('', '', window.location.origin + window.location.pathname + param)
}


export const isArray = (value) => {
    return Object.prototype.toString.call(value) === '[object Array]'
}

export const isString = (value) => {
    return Object.prototype.toString.call(value) === '[object String]'
}

export const isJSON = (value) => {
    if (typeof value == 'string') {
        try {
            let obj = JSON.parse(value);
            return typeof obj == 'object' && obj
        } catch (e) {
            return false;
        }
    }
}

export const getRelativeDatesInfo = () => {
    const daysMap = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    const today = new Date();
    const yesterday = new Date(today);
    const dayBeforeYesterday = new Date(today);

    yesterday.setDate(today.getDate() - 1);
    dayBeforeYesterday.setDate(today.getDate() - 2);

    return {
        today: {
            date: today.toLocaleDateString(),
            day: daysMap[today.getDay()]
        },
        yesterday: {
            date: yesterday.toLocaleDateString(),
            day: daysMap[yesterday.getDay()]
        },
        dayBeforeYesterday: {
            date: dayBeforeYesterday.toLocaleDateString(),
            day: daysMap[dayBeforeYesterday.getDay()]
        }
    };
}

// 示例用法
// const datesInfo = getRelativeDatesInfo();
// console.log(`今天: ${datesInfo.today.date} ${datesInfo.today.day}`);
// console.log(`昨天: ${datesInfo.yesterday.date} ${datesInfo.yesterday.day}`);
// console.log(`前天: ${datesInfo.dayBeforeYesterday.date} ${datesInfo.dayBeforeYesterday.day}`);
// 今天: 2025/10/14 星期二
// 昨天: 2025/10/13 星期一
// 前天: 2025/10/12 星期日

/**
 * 根据数组、值和key 获取选项
 * @param list
 * @param type
 * @param format
 * @returns {string|*}
 */
export const findByType = (list, type, format = {key: 'value', value: 'label'}) => {
    let find = list.find(f => {
        return type === f[format.key]
    })
    if (!find) return ''
    return find[format.value]
}


export const confirm = (title, msg, fn, confirmButtonText = '确认', showCancelButton = true, cancel = () => {}) => {
    MessageBox.confirm(
        msg, title, {
            confirmButtonText: confirmButtonText,
            type: 'warning',
            showClose: false,
            showCancelButton: showCancelButton,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            dangerouslyUseHTMLString: true
        }
    ).then(() => {
        fn()
    }).catch(() => {
        cancel()
    })
}

export const frontDownload = (url) =>{
    var a =  document. createElement('a') //創建一个<a></a>金
    a.href = url
    a.download //设置下载文件文件名
    a.target = '_blank'
    a.style.display ='none' //a
    document.body.appendChild(a) //将a标签追加到文档对象中
    a.click() //模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
    a.remove() //一次性的，用完就删除a标签
}


